require('es6-promise').polyfill();

import './main.less';
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router/router'

import VueSocketio from './ForkedModules/VueSocketIo/main';
process.env.NODE_ENV === 'production'
    ? Vue.use(VueSocketio, 'https://www.mixsii.com/')
    : Vue.use(VueSocketio, 'http://127.0.0.1:82/');

Vue.use(Vuex);

import './vueFilters.js';
import './vueComponents.js';
import imageReloader from './imageReloader';

import Store from './store.js';
let store = Store({Vue: Vue, Vuex: Vuex});

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App},

    sockets: {
        'serverReconnect'(){
            store.dispatch('loggedUserModel/fetchLoggedUserInfo', (user) => {
                if (user.isLoggedIn) {
                    this.$socket.emit("setUserSocketData", user.info);
                }
            });
        },

        'avatarUpdated'(data){
            imageReloader('/userdata/avatars/' + data.id + '.jpg');

            store.dispatch('loggedUserModel/fetchLoggedUserInfo', (user) => {
                if (user.isLoggedIn) {
                    this.$socket.emit("setUserSocketData", user.info);
                }
            });
        },

        'loggedOut'(){
            store.commit('loggedUserModel/unsetLoggedUserInfo');
            this.$socket.emit("unsetUserSocketData");
        }
    }
});



// WEBPACK FOOTER //
// ./src/main.js